import * as React from 'react';
import moment from 'moment/moment';
import { CartesianGrid, Legend, Line, LineChart, ReferenceLine, ResponsiveContainer, Tooltip, XAxis, YAxis} from 'recharts';
import * as PropTypes from 'prop-types';
import { formatMoment } from "../../../utils/util";
import { DateFormat } from "../../../store/pages/venues/types";
import { ProductStockLevel } from '../../../store/pages/productStock/types';

interface ProductStockLevelHistoryGraphProps {
    dateFormat: DateFormat;
    productStockLevel: ProductStockLevel;
    lowStockWarningQuantity: number | null;
}

class ProductStockLevelHistoryGraph extends React.Component<ProductStockLevelHistoryGraphProps> {
    constructor(props: ProductStockLevelHistoryGraphProps) {
        super(props);
    }

    static contextTypes = {
        t: PropTypes.func
    }
    
    render() {
        const { t } = this.context;
        const { dateFormat, productStockLevel, lowStockWarningQuantity } = this.props;
        const graphData = productStockLevel == null ? [] : productStockLevel.quantities.map(q => {
            return {
                date: formatMoment(moment(q.dateInLocalTime), dateFormat),
                isToday: moment(q.dateInLocalTime).isSame(moment(), 'day'),
                currentStock: q.currentStock,
                availableStock: q.availableStock,
                lowStockWarningQuantity: lowStockWarningQuantity,
            };
        });
        const todayDataValue = graphData.find(gd => gd.isToday)!.date;

        const lines = [
            { dataKey: 'currentStock', stroke: '#8884d8', label: t('ProductStockLevelHistoryGraph:currentStock'), dot: true},
            { dataKey: 'availableStock', stroke: '#82ca9d', label: t('ProductStockLevelHistoryGraph:availableStock'), dot: true},
        ];
        if (lowStockWarningQuantity) {
            lines.push({dataKey: 'lowStockWarningQuantity', stroke: '#ff0000', label: t('ProductStockLevelHistoryGraph:lowStockWarningQuantity'), dot: false});
        }

        return <div style={{margin: 20, backgroundColor: 'white'}}>
            <ResponsiveContainer width='100%' height={250}>
                <LineChart margin={{ top: 20, right: 30, left: 10, bottom: 10 }} data={graphData}>
                    <CartesianGrid strokeDasharray='3 3' />
                    <XAxis dataKey="date" type='category'/>
                    <YAxis />
                    <Tooltip />
                    <Legend  />
                    {lines.map(line => <Line dataKey={line.dataKey} stroke={line.stroke} name={line.label ?? line.dataKey} dot={line.dot} />)}
                    <ReferenceLine
                        x={todayDataValue}
                        stroke="#000000"
                        strokeWidth={2}
                        strokeDasharray="3 3"
                        label={{
                            value: t('ProductStockLevelHistoryGraph:todayIndicator'),
                            position: 'top',
                            fill: '#000000',
                            fontWeight: 'bold'
                        }
                    }></ReferenceLine>
                </LineChart>
            </ResponsiveContainer>
        </div>
    }
}

ProductStockLevelHistoryGraph.contextTypes = {
    t: PropTypes.func
}

export default ProductStockLevelHistoryGraph
